import { createCrudContext } from "./createCrudContext";

/**
 * The four level contexts (first/second/third/fourth) are ~212-line
 * duplicates of each other, parameterized only by the level name. This
 * factory collapses the duplicate boilerplate to one spec per level.
 *
 * On top of the standard CRUD endpoints:
 *   /api/v1/<level>/level/                     (list)
 *   /api/v1/admin/<level>/level/create         (create)
 *   /api/v1/admin/<level>/level/update/:id     (update)
 *   /api/v1/admin/<level>/level/delete/:id     (delete)
 * there are two level-specific endpoints:
 *   /api/v1/<level>/level/metadata/:id                 (fetch by id → sets `selected`)
 *   /api/v1/<level>/level/location/?country_id=X       (fetch by country → sets list)
 */
export const createLevelContext = (level) => {
  const cap = level[0].toUpperCase() + level.slice(1);

  return createCrudContext({
    name: `${level}Level`,
    listPath: `${level}/level`,
    adminPath: `${level}/level`,
    legacy: {
      data: `${level}Levels`,
      count: `count${cap}`,
      selected: `${level}Level`,
      fetch: `fetch${cap}Levels`,
      create: `add${cap}Level`,
      update: `update${cap}Level`,
      remove: `delete${cap}Level`,
      updateState: `update${cap}LevelState`,
    },
    extras: ({ request, setData, setCount, setSelected, API_URL }) => ({
      [`fetch${cap}Level`]: async (id) => {
        const response = await request.get(
          `${API_URL}/api/v1/${level}/level/metadata/${id}`,
        );
        if (response?.data?.data !== undefined) setSelected(response.data.data);
        return response;
      },
      [`fetch${cap}ByCountryId`]: async ({
        country_id,
        page = 1,
        pageSize = 20,
      }) => {
        const response = await request.get(
          `${API_URL}/api/v1/${level}/level/location/?page=${page}&pageSize=${pageSize}&country_id=${country_id}`,
        );
        if (response?.data?.data) {
          setData(response.data.data.data);
          setCount(response.data.data.count);
        }
        return response;
      },
    }),
  });
};
